<!-- <app-header [totalProducts]="cartCount" *ngIf="isShowNav"></app-header>
<app-toolbar class="hide-xs"></app-toolbar> -->

<!-- <app-loader></app-loader> -->
 <!-- <main role="main" class="min-h-screen">
<router-outlet (click)="closeMenuFromMainPage()"> </router-outlet>
</main>
<app-to-top></app-to-top>
<app-footer></app-footer> -->
<!-- <app-footer></app-footer> -->
<app-header [totalProducts]="cartCount" *ngIf="isShowNav"></app-header>
<app-toolbar></app-toolbar>

<main role="main" id="main-content" class="min-h-screen" [ngClass]="{ 'bg-[#E3E6E6]': isHomePage }"
 >
  <router-outlet (click)="closeMenuFromMainPage()"></router-outlet>
</main>

<app-to-top></app-to-top>
<app-footer></app-footer>
